import { render, staticRenderFns } from "./SalesProfit.vue?vue&type=template&id=780c3e33"
import script from "./SalesProfit.vue?vue&type=script&lang=js"
export * from "./SalesProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports